// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__caf {
  position: relative;
  border-radius: 16px;

  display: flex;
  flex-direction: column;
}

.wrapper__caf.highlighted__bcc {
  outline-style: solid;
  outline-width: 2px;
  outline-offset: -2px;

  &.warning__d09 {
    outline-color: var(--ring-icon-warning-color);
  }
}

.absoluteContent__f00 {
  position: absolute;
  top: calc(var(--ring-unit) * 2);
  right: calc(var(--ring-unit) * 2);

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: calc(var(--ring-unit) * 0.5);
}

.header__f42 {
  display: flex;
  flex: 0 0 auto;
  padding: calc(var(--ring-unit) * 4) calc(var(--ring-unit) * 4) 0 calc(var(--ring-unit) * 4);
  gap: calc(var(--ring-unit) * 2);

  .iconWrapper__ef7 {
    width: calc(var(--ring-unit) * 4);
    height: calc(var(--ring-unit) * 4);

    &.simpleIcon__e67 {
      display: flex;
      align-items: center;
      justify-content: center;

      color: var(--ring-main-color);
      border-radius: 4px;
      background-color: var(--ring-selected-background-color);
    }
  }

  .title__f4f {
    /*reset built-in margin to ring-ui H3 / H2*/
    margin: 0;
  }

  .title__f4f.titleMediumSize__a44 {
    font-size: var(--ring-font-size-larger);
  }

  .title__f4f.titleLargeSize__c4a {
    font-size: 20px;
  }
}

.controls__af4 {
  margin-top: auto;
  flex: 0 0 auto;
  height: calc(var(--ring-unit) * 7);

  display: flex;
  align-items: center;
  gap: calc(var(--ring-unit) * 2);
  padding: 0 calc(var(--ring-unit) * 4);
}

.mainContent__d9b {
  padding: 0 calc(var(--ring-unit) * 4) calc(var(--ring-unit) * 3) calc(var(--ring-unit) * 4);
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;

  &:last-child {
    padding-bottom: calc(var(--ring-unit) * 4);
  }
}

.wrapper__caf.filled__e0d {
  background-color: var(--ring-sidebar-background-color);

  .controls__af4 {
    border-top: 1px solid var(--ring-line-color);
  }
}

.wrapper__caf.outlined__eaf {
  background-color: var(--ring-content-background-color);
  border: 1px solid var(--ring-borders-color);

  .controls__af4 {
    border-top: 1px solid var(--ring-borders-color);
  }
}

.wrapper__caf.wide__de9 {
  width: calc(var(--ring-unit) * 54);
  min-height: calc(var(--ring-unit) * 32);

  .header__f42 {
    align-items: center;
  }

  .header__f42 + .mainContent__d9b {
    margin-top: calc(var(--ring-unit) * 3);
  }
}

.wrapper__caf.medium__a1f {
  width: calc(var(--ring-unit) * 45);
  min-height: calc(var(--ring-unit) * 40);

  .header__f42 {
    flex-direction: column;
    align-items: flex-start;
  }

  .header__f42 + .mainContent__d9b {
    margin-top: calc(var(--ring-unit) * 2);
  }
}

.wrapper__caf.contentBottom__c7f:not(.loading__f47) .mainContent__d9b {
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/common/widgets/widget/widget.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;;EAEnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;;EAEpB;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;;EAEjC,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,2FAA2F;EAC3F,+BAA+B;;EAE/B;IACE,iCAAiC;IACjC,kCAAkC;;IAElC;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;;MAEvB,6BAA6B;MAC7B,kBAAkB;MAClB,uDAAuD;IACzD;EACF;;EAEA;IACE,2CAA2C;IAC3C,SAAS;EACX;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;;EAElC,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,2FAA2F;EAC3F,cAAc;EACd,aAAa;EACb,sBAAsB;;EAEtB;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,sDAAsD;;EAEtD;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,sDAAsD;EACtD,2CAA2C;;EAE3C;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;;EAEvC;IACE,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;;EAEvC;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".wrapper {\n  position: relative;\n  border-radius: 16px;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.wrapper.highlighted {\n  outline-style: solid;\n  outline-width: 2px;\n  outline-offset: -2px;\n\n  &.warning {\n    outline-color: var(--ring-icon-warning-color);\n  }\n}\n\n.absoluteContent {\n  position: absolute;\n  top: calc(var(--ring-unit) * 2);\n  right: calc(var(--ring-unit) * 2);\n\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: calc(var(--ring-unit) * 0.5);\n}\n\n.header {\n  display: flex;\n  flex: 0 0 auto;\n  padding: calc(var(--ring-unit) * 4) calc(var(--ring-unit) * 4) 0 calc(var(--ring-unit) * 4);\n  gap: calc(var(--ring-unit) * 2);\n\n  .iconWrapper {\n    width: calc(var(--ring-unit) * 4);\n    height: calc(var(--ring-unit) * 4);\n\n    &.simpleIcon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      color: var(--ring-main-color);\n      border-radius: 4px;\n      background-color: var(--ring-selected-background-color);\n    }\n  }\n\n  .title {\n    /*reset built-in margin to ring-ui H3 / H2*/\n    margin: 0;\n  }\n\n  .title.titleMediumSize {\n    font-size: var(--ring-font-size-larger);\n  }\n\n  .title.titleLargeSize {\n    font-size: 20px;\n  }\n}\n\n.controls {\n  margin-top: auto;\n  flex: 0 0 auto;\n  height: calc(var(--ring-unit) * 7);\n\n  display: flex;\n  align-items: center;\n  gap: calc(var(--ring-unit) * 2);\n  padding: 0 calc(var(--ring-unit) * 4);\n}\n\n.mainContent {\n  padding: 0 calc(var(--ring-unit) * 4) calc(var(--ring-unit) * 3) calc(var(--ring-unit) * 4);\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n\n  &:last-child {\n    padding-bottom: calc(var(--ring-unit) * 4);\n  }\n}\n\n.wrapper.filled {\n  background-color: var(--ring-sidebar-background-color);\n\n  .controls {\n    border-top: 1px solid var(--ring-line-color);\n  }\n}\n\n.wrapper.outlined {\n  background-color: var(--ring-content-background-color);\n  border: 1px solid var(--ring-borders-color);\n\n  .controls {\n    border-top: 1px solid var(--ring-borders-color);\n  }\n}\n\n.wrapper.wide {\n  width: calc(var(--ring-unit) * 54);\n  min-height: calc(var(--ring-unit) * 32);\n\n  .header {\n    align-items: center;\n  }\n\n  .header + .mainContent {\n    margin-top: calc(var(--ring-unit) * 3);\n  }\n}\n\n.wrapper.medium {\n  width: calc(var(--ring-unit) * 45);\n  min-height: calc(var(--ring-unit) * 40);\n\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .header + .mainContent {\n    margin-top: calc(var(--ring-unit) * 2);\n  }\n}\n\n.wrapper.contentBottom:not(.loading) .mainContent {\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__caf`,
	"highlighted": `highlighted__bcc`,
	"warning": `warning__d09`,
	"absoluteContent": `absoluteContent__f00`,
	"header": `header__f42`,
	"iconWrapper": `iconWrapper__ef7`,
	"simpleIcon": `simpleIcon__e67`,
	"title": `title__f4f`,
	"titleMediumSize": `titleMediumSize__a44`,
	"titleLargeSize": `titleLargeSize__c4a`,
	"controls": `controls__af4`,
	"mainContent": `mainContent__d9b`,
	"filled": `filled__e0d`,
	"outlined": `outlined__eaf`,
	"wide": `wide__de9`,
	"medium": `medium__a1f`,
	"contentBottom": `contentBottom__c7f`,
	"loading": `loading__f47`
};
export default ___CSS_LOADER_EXPORT___;
